<template>
    <div id="app">
        <transition name="menuAppear" enter-active-class="slideInLeft" leave-active-class="slideOutLeft">
            <Nav style="animation-duration: .5s" v-show="menuTriger" @menuopen="openMenu"/>
        </transition>
        <div class="mainContent">
            <Alert/>
            <Promt/>
            <TopBar v-if="loaded" @menuopen="openMenu"/>
            <!--PageLoader-->
            <transition
                name="fade"
            >
                <Pageloader v-if="showPageLoader"/>
            </transition>
            <transition
                enter-active-class="slideInRight">
                <router-view v-if="loaded" style="animation-duration: .5s"/>
            </transition>
            <BottomBar v-if="!user" />
        </div>
    </div>
</template>
<script>
    import TopBar from "./components/TopBar";
    import BottomBar from "./components/BottomBar";
    import Nav from "./components/Nav";
    import Pageloader from "./components/loader/Pageloader";
    import Alert from "./components/shared/Alert";
    import Promt from "./components/shared/Promt";

    export default {
        components: {Promt, Alert, Nav, BottomBar, TopBar, Pageloader},
        data(){
          return{
              menuTriger:false,
              loaded: false,
          }
        },
        created() {
            this.$store.commit("cart/initCart");
            this.$store.dispatch("menu/getMenuCategories");
            this.$store.dispatch("shared/getGatewayInfo");
            this.$store.dispatch("businesses/initGeoLocation");
            this.$store.dispatch("businesses/loadBusinesses", (businesses)=>{
                this.$store.dispatch("businesses/calcClosest");
                let bid;
                let business;
                if (this.$route.params.business_id){
                    bid = this.$route.params.business_id;
                    business = this.$store.getters["businesses/getBusinessById"](bid);
                }else{
                    bid = businesses[0]?.business_id
                    business = businesses[0];
                }
                this.$store.commit("shared/setBusinessId", bid)
                this.$store.commit("cart/setBusiness", business);
                this.mapSettings.selectedBusinessID = bid;
                this.loaded = true;
            });
            
            window.addEventListener('keydown', (e)=>{
                if(document.activeElement === document.body) {
                    switch (e.keyCode) {
                        case 37:
                            this.$router.go(-1);
                            break;
                        case 39:
                            this.$router.go(1);
                            break;
                    }
                }
            });
        },
        computed: {
            showPageLoader() {
                return this.$store.state.shared.processRequestCount;
            },
            mapSettings(){
                return this.$store.state.businesses.mapSettings;
            }
        },
        methods: {
            openMenu(){
                this.menuTriger = !this.menuTriger;
            }
        }
    }
</script>
